// Nav
export const esNavItem1 = "Inicio";
export const esNavItem2 = "Perfil";
export const esNavItem3 = "Proyectos";
export const esNavItem4 = "Contacto";
export const esNavItem5 = "Idioma";
export const esNavItem6 = "Inglés"
export const esNavItem7 = "Español"

export const hiThereEs = 'Hola, bienvenido a mi página web';
export const myProfileES = 'Mira mis proyectos';

// Footer Contact
export const contactEs = "https://api.whatsapp.com/send?phone=+447864069428&text=Hola!%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20de%20tus%20servicios%20como%20desarrollador/programador%20Web."


// Copyright
export const copyrightEs = `${new Date().getFullYear()} Cristian Herrera, Web Developer`;

// Profile
export const h4Es1 = "INFORMACION PERSONAL";
export const boldEs1 = "Nombre Completo: ";
export const pEs1 = "Cristian Daniel Herrera";
export const boldEs6 = "Nacionalidad: ";
export const pEs12 = "Argentino"
export const boldEs2 = "Email: ";
export const pEs2 = "cristian.daniel.herrera@hotmail.com";
export const boldEs3 = "Linkedin: "
export const pEs3 = "Click aqui"
export const boldEs4 = "GitHub: "
export const pEs4 = "Click aqui"

export const h4Es2 = "PERFIL"
export const pEs5 = "Después de trabajar como músico profesional durante varios años, ahora estoy buscando comenzar una nueva carrera en Programación y Desarrollo Web. Soy una persona entusiasta y motivada que está dispuesta a aprender nuevas habilidades y trabajar como parte de un equipo. Recientemente completé un curso introductorio de Programación. Ahora estoy haciendo un nuevo curso en Javascript Avanzado y buscando trabajo en este campo para aplicar este nuevo conocimiento de una manera práctica. ";

export const h4Es3 = "EXPERIENCIA LABORAL"
export const pEs6 = "Estuve haciendo trainee en The Bit Cooperative Ltda por dos años en Buenos Aires, Argentina. Aprendi el stack MERN y pude construir un e-commerce. Ellos me ofrecieron una posición como junior, pero desafortunadamente no acepté por que me mude a Reino Unido.";
export const boldEs5 = "Carta de recomendacion: "
export const pEs7 = "Click aqui"

export const h4Es4 = "EDUCACION"
export const pEs8 = "HTML, CSS, Javascript, Bootstrap. Mayo 2020 - Agosto 2020, UTN"
export const pEs9 = "FullStack (Stack MERN). Agosto 2020 - Diciembre 2021, NucBA"
export const pEs10 = "Udemy (NodeJs). Mayo 2021 - Junio 2021"
export const pEs11 = "IT Career (HTML, CSS, JavaScript, Testing, React, Nodejs, Postgresql, SQL, PHP, Python, C#, Java, Jquery. Agosto 2021 - Abril 2022. It career en Reino Unido"; 

export const h4Es5 = "LANGUAJES Y FRAMEWORKS"

export const downloadCvEs = "Bajate mi curriculum"

// Projects
export const projectEs = "Proyecto"
export const descriptionEs = "Descripción"
export const tecnoligiesEs = "Tecnologías"
export const videoEs = "Video demostración"
